import styled from '@themes/theme'

export const SharedBettingListWrap = styled.div`
  width: 100%;
  max-height: 50vh;
  overflow: auto;
  background: ${props => props.theme.color.modalBg};
  border-top: 1px solid ${props => props.theme.color.modalBg};
  // 상단 폴드/배당 정보
  .shared-betting-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 74px;
    padding: 0 30px 0 16px;
    // 적중/미적중/적특 상태 이미지
    .hit-state-img {
      width: auto;
      height: 32px;
      margin-right: 7px;
    }
    .division-line {
      width: 1px;
      height: 39px;
      margin: 0 13px;
      background: ${props => props.theme.color.modalSubBg2};
      box-shadow: 1px 0 1px rgba(255, 255, 255, .7);
    }
    &--item {
      flex: 1;
      display: inline-flex;
      flex-flow: column;
      min-width: 90px;
      &--num {
        font-size: ${props => props.theme.font.xxlarge};
        color: ${props => props.theme.color.modalTxt};
        &.rate {
          color: ${props => props.theme.color.modalOrange};
        }
      }
      &--txt {
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.modalTxt};
        .additional-dividend-mark {
          display: inline-block;
          width: 26px;
          height: 26px;
          text-align: center;
          line-height: 23px;
          vertical-align: middle;
          margin-top: -2px;
          margin-left: -3px;
          margin-right: -7px;
          img {
            width: auto;
            height: 15px;
          }
          & + .oz-cancel {
            margin-left: 4px;
          }
        }
      }
    }
  }

  // 베팅 내역 상세 내용
  .shared-list-header {
    width: 100%;
    height: auto;
    margin: 0;
    padding-bottom: 7px;
    border-radius: 0;
    background: ${props => props.theme.color.themeTxt};
    .betting-history-header {
      padding: 0 8px;
      .fold-money-list {
        padding: 14px 10px 10px;
        &--item.fold {
          .sports-ico-wrap {
            margin-left: 6px;
          }
        }
      }
    }
  }
  &.pc-shared-betting-list-wrap {
    max-height: 400px;
  }
`
